import { combineReducers } from 'redux';
import userInfo from "./reducers/userInfo";
import popups from "./reducers/popup";

const rootReducer = combineReducers({
    userInfo,
    popups
})

export default rootReducer;